import { Dialog, IconButton, DialogContent } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import React from 'react';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import DeliveryBatchForm from './create-task-form/create-delivery-task-form';
import { useSnackBar } from '../../../contexts/snackbar';

interface DeliveryBatchDialogProps {
  onClose: () => void;
  taskID: string;
}
function DeliveryBatchDialog({ taskID, onClose }: DeliveryBatchDialogProps) {
  const { showMessage } = useSnackBar();
  return (
    <CustomDialog
      open={true}
      fullWidth
      maxWidth="xl"
      fullScreen={(isMobile && !isTablet)}
      onClose={onClose}
    >
      <div
        style={{
          textAlign: 'right',
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <IconButton onClick={onClose}>
          <ClearIcon color="primary" fontSize="large" />
        </IconButton>
      </div>

      <DialogContent style={(isDesktop || isTablet) ? { width: '100%', height: '100%' } : {}}>
        <DeliveryBatchForm
          taskID={taskID}
          onSuccess={() => {
            showMessage('Batch updated successfully!');
            onClose();
          }}
        />
      </DialogContent>
    </CustomDialog>
  );
}

export default DeliveryBatchDialog;
